import _, { findIndex, isEmpty, isUndefined } from 'lodash';
import {
    humanNamePrefixOptionsOptionsList,
    humanNameSuffixOptionsList,
} from '../../data/fhirHumanNameData';
import {
    fetchOrganizationDataFromApi,
    fetchPregnancyAndBreastFeedingDataOfFemalePatient,
} from '../services/services';
import dayjs from 'dayjs';
import { ehrAPIBaseService, ehrAPIService } from '../../http-common';
import { DIAGNOSIS_SEQUENCE } from '../claims_lists';

const getOrganizationData = async () => {
    let response = null;
    try {
        let searchQuery = `search/?_elements=id,name,type&_sort=name&_type=Organization,Practitioner`;
        response = await ehrAPIService.get(searchQuery);
    } catch (e) {
        console.error(`fhirPatient->getOrganizationAndPractionerData`, e);
    }

    return response;
};

export const flatObjectFromFhirClaim = async props => {
    const claimResponseId = props?.claimResponseId;
    const patientId = props?.patient?.reference?.split('/')?.[1];
    const claimId = props?.id;
    const claimItems = props?.item;
    const claimDiagnosis = props?.diagnosis;
    const preAuthRef =
        props?.preAuthRef || props?.insurance?.[0]?.preAuthRef?.[0] || '';
    const coverageId =
        props?.insurance?.[0]?.coverage?.reference?.split('/')?.[1];

    const billingProviderId = props?.provider?.reference?.split('/')?.[1];
    const renderingProviderId =
        props?.careTeam?.[
            findIndex(
                props?.careTeam,
                o => o?.role?.coding?.[0]?.code === 'primary'
            )
        ]?.provider?.reference?.split('/')?.[1];

    const supervisingProviderId =
        props?.careTeam?.[
            findIndex(
                props?.careTeam,
                o => o?.role?.coding?.[0]?.code === 'supervisor'
            )
        ]?.provider?.reference?.split('/')?.[1];

    const referringProviderId =
        props?.careTeam?.[
            findIndex(
                props?.careTeam,
                o => o?.role?.coding?.[0]?.code === 'assist'
            )
        ]?.provider?.reference?.split('/')?.[1];

    const billingProviderObject = props?.provider?.reference;
    const renderingProviderObject =
        props?.careTeam?.[
            findIndex(
                props?.careTeam,
                o => o?.role?.coding?.[0]?.code === 'primary'
            )
        ]?.provider?.reference;

    const supervisingProviderObject =
        props?.careTeam?.[
            findIndex(
                props?.careTeam,
                o => o?.role?.coding?.[0]?.code === 'supervisor'
            )
        ]?.provider?.reference;

    const referringProviderObject =
        props?.careTeam?.[
            findIndex(
                props?.careTeam,
                o => o?.role?.coding?.[0]?.code === 'assist'
            )
        ]?.provider?.reference;

    let illnessDate = props?.accident?.date;
    let hospitalizationStart =
        props?.supportingInfo && props?.supportingInfo[0]?.timingPeriod?.start;
    let hospitalizationEnd =
        props?.supportingInfo && props?.supportingInfo[0]?.timingPeriod?.end;

    let patientObject = null;
    let coverageObject = null;
    let billingProvider = {
        display: '',
        data: {},
        code: billingProviderObject,
    };

    let renderingProvider = {
        code: renderingProviderObject,
    };

    let supervisingProvider = {
        code: supervisingProviderObject,
    };

    let referringProvider = {
        code: referringProviderObject,
    };

    let claimObject = null;
    let oldClaimId = undefined;

    try {
        // const response = await ehrAPIService.get(
        //   `getResource?resourceType=Patient&resourceId=${patientId}`
        // );

        // patientObject = response?.data;

        // const response1 = await ehrAPIService.get(
        //   `getResource?resourceType=Coverage&resourceId=${coverageId}`
        // );

        // coverageObject = response1?.data;

        let url = `fhir/search/?_type=Organization,Practitioner,Patient,Coverage,Claim&_id=${patientId},${coverageId},${claimId}`;

        if (billingProviderId) {
            url += `,${billingProviderId}`;
        }
        if (renderingProviderId) {
            url += `,${renderingProviderId}`;
        }
        if (referringProviderId) {
            url += `,${referringProviderId}`;
        }

        if (supervisingProviderId) {
            url += `,${supervisingProviderId}`;
        }

        const response4 = await ehrAPIBaseService.get(url);

        for (const item of response4?.data?.entry) {
            if (item?.resource?.id === claimId) {
                claimObject = item?.resource;
                oldClaimId = claimObject?.related?.reference?.split('/')?.[1];
            }

            if (item?.resource?.id === patientId) {
                patientObject = item?.resource;
            }

            if (item?.resource?.id === coverageId) {
                coverageObject = {
                    code: item?.resource?.id,
                    display: `Coverage ${
                        DIAGNOSIS_SEQUENCE[item?.resource?.order - 1]
                    }`,
                    label: item?.resource,
                    value: `Coverage ${
                        DIAGNOSIS_SEQUENCE[item?.resource?.order - 1]
                    }`,
                    resource: item?.resource,
                };
            }

            if (item?.resource?.id === billingProviderId) {
                billingProvider.display =
                    item?.resource?.resourceType === 'Organization'
                        ? item?.resource?.name
                        : item?.resource?.name?.[0]?.text;
                billingProvider.data = item?.resource;
            }

            if (item?.resource?.id === renderingProviderId) {
                renderingProvider.display = item?.resource?.name?.[0]?.text;
                renderingProvider.data = item?.resource;
            }

            if (item?.resource?.id === referringProviderId) {
                referringProvider.display = item?.resource?.name?.[0]?.text;
                referringProvider.data = item?.resource;
            }

            if (item?.resource?.id === supervisingProviderId) {
                supervisingProvider.display = item?.resource?.name?.[0]?.text;
                supervisingProvider.data = item?.resource;
            }
        }
    } catch (e) {
        console.error(`fhirPatient->flatObjectFromFhirClaim`, e);
    }

    return {
        billingProvider,
        renderingProvider,
        referringProvider,
        supervisingProvider,
        illnessDate,
        hospitalizationEnd,
        hospitalizationStart,
        patientObject,
        coverageObject,
        claimId,
        claimItems,
        isEditMode: Boolean(claimId),
        claimDiagnosis,
        claimResponseId,
        oldClaimId,
        preAuthRef,
    };
};

export const flatObjectFromFhirPractitioner = async props => {
    let rawItem = props;
    let rawNameItem = rawItem?.name?.[0];
    let rawOfficialAddressItem = rawItem?.address?.[0];
    let rawBillingAddressItem = !_.isUndefined(rawItem?.address?.[1])
        ? rawItem?.address?.[1]
        : {};
    let rawPhoneItems = rawItem?.telecom?.filter(o => o.system === 'phone');
    let homePhoneNumber =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'home')];
    let mobileNumber =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'mobile')];
    let emailAddress = rawItem?.telecom?.filter(o => o.system === 'email')?.[0];

    let newSingleRow = {
        name: {
            displaySuffix: '',
            displayPrefix: '',
            firstName: '',
            middleName: '',
            lastName: '',
            fullNameText: '',
        },
        address: {
            official: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                country: '',
                postalCode: '',
            },
            billing: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                country: '',
                postalCode: '',
            },
        },
        contacts: {
            homePhoneNumber: '',
            mobileNumber: '',
            emailAddress: '',
        },
    };

    newSingleRow.id = rawItem?.id;

    //TODO: Name
    newSingleRow.name.suffix = rawNameItem?.suffix?.[0];
    newSingleRow.name.prefix = rawNameItem?.prefix?.[0];

    newSingleRow.name.displayPrefix =
        humanNamePrefixOptionsOptionsList?.[
            _.findIndex(
                humanNamePrefixOptionsOptionsList,
                o => o?.code === newSingleRow?.name?.prefix
            )
        ];
    newSingleRow.name.displaySuffix =
        humanNameSuffixOptionsList?.[
            _.findIndex(
                humanNameSuffixOptionsList,
                o => o?.code === newSingleRow?.name?.suffix
            )
        ];

    newSingleRow.name.firstName = rawNameItem?.given?.[0];
    newSingleRow.name.middleName = rawNameItem?.given?.[1];
    newSingleRow.name.lastName = rawNameItem?.given?.[2];
    newSingleRow.name.fullNameText = rawNameItem?.text;
    newSingleRow.photoUrl = rawItem?.photo?.[0]?.url;
    //TODO:End

    //TODO: Identifier
    newSingleRow.SSNObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'SS'
            )
        ];

    newSingleRow.GovernmentIdObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'NI'
            )
        ];
    newSingleRow.DrivingLicenseObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'DL'
            )
        ];
    newSingleRow.PassportObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'PPN'
            )
        ];
    newSingleRow.InsuranceIdentificationObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'NII'
            )
        ];

    newSingleRow.LicenseIdentificationObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'MD'
            )
        ];

    newSingleRow.CertificateIdentificationObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'AC'
            )
        ];
    //TODO

    //TODO: Address
    newSingleRow.address.official.addressLine1 =
        rawOfficialAddressItem?.line?.[0];
    newSingleRow.address.official.addressLine2 =
        rawOfficialAddressItem?.line?.[1];
    newSingleRow.address.official.city = rawOfficialAddressItem?.city;
    newSingleRow.address.official.state = rawOfficialAddressItem?.state;
    newSingleRow.address.official.country = rawOfficialAddressItem?.country;
    newSingleRow.address.official.postalCode =
        rawOfficialAddressItem?.postalCode;

    newSingleRow.address.sameAsOfficial = true;

    if (!_.isEmpty(rawBillingAddressItem)) {
        newSingleRow.address.sameAsOfficial = false;
        newSingleRow.address.billing.addressLine1 =
            rawBillingAddressItem?.line?.[0];
        newSingleRow.address.billing.addressLine2 =
            rawBillingAddressItem?.line?.[1];
        newSingleRow.address.billing.city = rawBillingAddressItem?.city;
        newSingleRow.address.billing.state = rawBillingAddressItem?.state;
        newSingleRow.address.billing.country = rawBillingAddressItem?.country;
        newSingleRow.address.billing.postalCode =
            rawBillingAddressItem?.postalCode;
    }

    //TODO: End

    //TODO: Telcom
    newSingleRow.contacts.homePhoneNumber = homePhoneNumber;
    newSingleRow.contacts.mobileNumber = mobileNumber;
    newSingleRow.contacts.emailAddress = emailAddress;
    //TODO: End

    //TODO: Others
    newSingleRow.active = rawItem?.active;
    newSingleRow.birthDate = rawItem?.birthDate;
    newSingleRow.birthDateDisplay = dayjs(newSingleRow?.birthDate).format(
        'DD MMM YYYY'
    );
    newSingleRow.gender = rawItem?.gender;
    //TODO: End

    const [optionsArrayGP, optionsArrayProv, optionsArrayOrg] =
        await fetchOrganizationDataFromApi(['prov', 'gp', 'org']);
    newSingleRow.generalPractitionerOptionsList = optionsArrayGP;
    newSingleRow.providerOptionsList = optionsArrayProv;
    newSingleRow.managingOrganizationOptionsList = optionsArrayOrg;

    let concatGPandMO = optionsArrayGP.concat(optionsArrayOrg);

    //   newSingleRow.managingOrganizationDisplayList = rawItem?.managingOrganization;
    newSingleRow.managingOrganizationDisplayList =
        optionsArrayOrg?.[
            _.findIndex(
                optionsArrayOrg,
                o => o?.code === rawItem?.managingOrganization?.reference
            )
        ];
    newSingleRow.generalPractitionerDisplayList =
        rawItem?.generalPractitioner?.map(item => {
            let newItem =
                concatGPandMO?.[
                    _.findIndex(concatGPandMO, o => o?.code === item?.reference)
                ];
            return {
                ...newItem,
            };
        });

    newSingleRow.fullRawData = { ...rawItem };

    return newSingleRow;
};

export const flatObjectFromFhirPatient = async props => {
    debugger;
    if (isEmpty(props)) {
        return null;
    }

    let rawItem = props;
    let rawNameItem = rawItem?.name?.[0];
    let rawOfficialAddressItem = rawItem?.address?.[0];
    let rawBillingAddressItem = !_.isUndefined(rawItem?.address?.[1])
        ? rawItem?.address?.[1]
        : {};
    let rawPhoneItems = rawItem?.telecom?.filter(o => o.system === 'phone');
    let homePhoneNumber =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'home')];
    let mobileNumber =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'mobile')];
    let emailAddress = rawItem?.telecom?.filter(o => o.system === 'email')?.[0];

    let newSingleRow = {
        name: {
            displaySuffix: '',
            displayPrefix: '',
            firstName: '',
            middleName: '',
            lastName: '',
            fullNameText: '',
        },
        address: {
            official: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                country: '',
                postalCode: '',
            },
            billing: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                country: '',
                postalCode: '',
            },
        },
        contacts: {
            homePhoneNumber: '',
            mobileNumber: '',
            emailAddress: '',
        },
    };

    newSingleRow.id = rawItem?.id;

    //TODO: Name
    newSingleRow.name.suffix = rawNameItem?.suffix?.[0];
    newSingleRow.name.prefix = rawNameItem?.prefix?.[0];

    newSingleRow.name.displayPrefix =
        humanNamePrefixOptionsOptionsList?.[
            _.findIndex(
                humanNamePrefixOptionsOptionsList,
                o => o?.code === newSingleRow?.name?.prefix
            )
        ];
    newSingleRow.name.displaySuffix =
        humanNameSuffixOptionsList?.[
            _.findIndex(
                humanNameSuffixOptionsList,
                o => o?.code === newSingleRow?.name?.suffix
            )
        ];

    newSingleRow.name.firstName = rawNameItem?.given?.[0];
    newSingleRow.name.middleName = rawNameItem?.given?.[1];
    newSingleRow.name.lastName = rawNameItem?.given?.[2];
    newSingleRow.name.fullNameText = rawNameItem?.text;
    newSingleRow.photoUrl = rawItem?.photo?.[0]?.url;
    //TODO:End

    //TODO: Identifier
    newSingleRow.SSNObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'SS'
            )
        ];

    newSingleRow.GovernmentIdObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'NI'
            )
        ];
    newSingleRow.DrivingLicenseObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'DL'
            )
        ];
    newSingleRow.PassportObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'PPN'
            )
        ];
    newSingleRow.InsuranceIdentificationObject =
        rawItem?.identifier?.[
            _.findIndex(
                rawItem?.identifier,
                o => o?.type?.coding?.[0]?.code === 'NII'
            )
        ];
    //TODO

    //TODO: Address
    newSingleRow.address.official.addressLine1 =
        rawOfficialAddressItem?.line?.[0];
    newSingleRow.address.official.addressLine2 =
        rawOfficialAddressItem?.line?.[1];
    newSingleRow.address.official.city = rawOfficialAddressItem?.city;
    newSingleRow.address.official.state = rawOfficialAddressItem?.state;
    newSingleRow.address.official.country = rawOfficialAddressItem?.country;
    newSingleRow.address.official.postalCode =
        rawOfficialAddressItem?.postalCode;

    newSingleRow.address.sameAsOfficial = true;

    if (!_.isEmpty(rawBillingAddressItem)) {
        newSingleRow.address.sameAsOfficial = false;
        newSingleRow.address.billing.addressLine1 =
            rawBillingAddressItem?.line?.[0];
        newSingleRow.address.billing.addressLine2 =
            rawBillingAddressItem?.line?.[1];
        newSingleRow.address.billing.city = rawBillingAddressItem?.city;
        newSingleRow.address.billing.state = rawBillingAddressItem?.state;
        newSingleRow.address.billing.country = rawBillingAddressItem?.country;
        newSingleRow.address.billing.postalCode =
            rawBillingAddressItem?.postalCode;
    }

    //TODO: End

    //TODO: Telcom
    newSingleRow.contacts.homePhoneNumber = homePhoneNumber;
    newSingleRow.contacts.mobileNumber = mobileNumber;
    newSingleRow.contacts.emailAddress = emailAddress;
    //TODO: End

    //TODO: Others
    newSingleRow.active = rawItem?.active;
    newSingleRow.birthDate = rawItem?.birthDate;
    newSingleRow.birthDateDisplay = dayjs(newSingleRow?.birthDate).format(
        'DD MMM YYYY'
    );
    newSingleRow.gender = rawItem?.gender;
    newSingleRow.link = rawItem?.link;
    //TODO: End

    const primaryCareId =
        rawItem?.generalPractitioner?.[0]?.reference?.split('/')?.[1];
    const generalPractitionerId =
        rawItem?.generalPractitioner?.[1]?.reference?.split('/')?.[1];
    const managingOrganizationId =
        rawItem?.managingOrganization?.reference?.split('/')?.[1];

    try {
        let url = `fhir/search/?_type=Organization,Practitioner&_id=${primaryCareId}`;
        if (!isUndefined(managingOrganizationId)) {
            url += `,${managingOrganizationId}`;
        }
        if (!isUndefined(generalPractitionerId)) {
            url += `,${generalPractitionerId}`;
        }
        const response = await ehrAPIBaseService.get(url);
        if (response?.data?.entry) {
            for (const item of response?.data?.entry) {
                if (item?.resource?.id === primaryCareId) {
                    newSingleRow.primaryCareObject = {
                        code: `${item?.resource?.resourceType}/${primaryCareId}`,
                        display:
                            item?.resource?.resourceType === 'Practitioner'
                                ? item?.resource?.name?.[0]?.text
                                : item?.resource?.name,
                        data: item?.resource,
                    };
                }

                if (item?.resource?.id === generalPractitionerId) {
                    newSingleRow.generalPractitionerObject = {
                        code: `${item?.resource?.resourceType}/${generalPractitionerId}`,
                        display: item?.resource?.name?.[0]?.text,
                        data: item?.resource,
                    };
                }

                if (item?.resource?.id === managingOrganizationId) {
                    newSingleRow.managingOrganizationObject = {
                        code: `${item?.resource?.resourceType}/${managingOrganizationId}`,
                        display: item?.resource?.name,
                        data: item?.resource,
                    };
                }
            }
        }
    } catch (e) {
        console.error(e);
    } finally {
    }

    const [optionsArrayGP, optionsArrayProv, optionsArrayOrg] =
        await fetchOrganizationDataFromApi(['prov', 'gp', 'org']);
    newSingleRow.generalPractitionerOptionsList = optionsArrayGP;
    newSingleRow.providerOptionsList = optionsArrayProv;
    newSingleRow.managingOrganizationOptionsList = optionsArrayOrg;

    let concatGPandMO = optionsArrayGP.concat(optionsArrayOrg);

    //   newSingleRow.managingOrganizationDisplayList = rawItem?.managingOrganization;
    newSingleRow.managingOrganizationDisplayList =
        optionsArrayOrg?.[
            _.findIndex(
                optionsArrayOrg,
                o => o?.code === rawItem?.managingOrganization?.reference
            )
        ];
    newSingleRow.generalPractitionerDisplayList =
        rawItem?.generalPractitioner?.map(item => {
            let newItem =
                concatGPandMO?.[
                    _.findIndex(concatGPandMO, o => o?.code === item?.reference)
                ];
            return {
                ...newItem,
            };
        });

    newSingleRow.fullRawData = { ...rawItem };

    if (newSingleRow?.gender === 'female') {
        // debugger;
        const response =
            await fetchPregnancyAndBreastFeedingDataOfFemalePatient(
                newSingleRow?.id
            );

        if (response?.data?.entry) {
            for (const item of response?.data?.entry) {
                const resource = item?.resource;
                if (resource?.code?.coding?.[0]?.code === '82810-3') {
                    let pregnancyObject = {
                        id: resource?.id,
                        code: resource?.code?.coding?.[0]?.code,
                        isPregnant:
                            resource?.valueCodeableConcept?.coding?.[0]
                                ?.code === 'LA15173-0'
                                ? true
                                : false,
                    };

                    newSingleRow.pregnancyObject = pregnancyObject;
                }

                if (resource?.code?.coding?.[0]?.code === '63895-7') {
                    let breastFeedingObject = {
                        id: resource?.id,
                        code: resource?.code?.coding?.[0]?.code,
                        isBreastFeeding:
                            resource?.valueCodeableConcept?.coding?.[0]
                                ?.code === 'LA29252-6'
                                ? true
                                : false,
                    };
                    newSingleRow.breastFeedingObject = breastFeedingObject;
                }
            }
        }
    }

    return newSingleRow;
};

export const flatObjectFromFhirAppointment = async props => {};
export const flatObjectFromFhirEncounter = async props => {};

export const flatObjectFromFhirOrganization = (props, selectedVersion) => {
    const identifier = props?.identifier;
    const niip =
        identifier?.[
            _.findIndex(identifier, o => o?.type?.coding?.[0].code === 'NIIP')
        ]?.value;
    const tax =
        identifier?.[
            _.findIndex(identifier, o => o?.type?.coding?.[0].code === 'TAX')
        ]?.value;
    const npi =
        selectedVersion === 'IN'
            ? identifier?.[
                  _.findIndex(
                      identifier,
                      o => o?.type?.coding?.[0].code === 'NMC'
                  )
              ]?.value
            : identifier?.[
                  _.findIndex(
                      identifier,
                      o => o?.type?.coding?.[0].code === 'NPI'
                  )
              ]?.value;

    const addressTemp = props?.address?.[0];
    const addressObject = {
        addressLine1: addressTemp?.line?.[0],
        addressLine2: addressTemp?.line?.[1],
        city: addressTemp?.city,
        state: addressTemp?.state,
        country: addressTemp?.country,
        postalCode: addressTemp?.postalCode,
    };

    const typeObject = {
        code: props?.type?.[0]?.coding?.[0]?.code,
        display: props?.type?.[0]?.coding?.[0]?.display,
    };

    let rawPhoneItems = props?.telecom?.filter(o => o.system === 'phone');
    let phone =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'home')]
            ?.value;
    let mobile =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'mobile')]
            ?.value;
    let email = props?.telecom?.filter(o => o.system === 'email')?.[0]?.value;

    // console.log("MBX", email);
    // const phone = props?.telecom?.[0]?.value;
    // const mobile = props?.telecom?.[1]?.value;
    // const email = props?.telecom?.[2]?.value;

    return {
        id: props?.id,
        name: props?.name,
        address: addressObject,
        fullRawData: props,
        type: typeObject,
        phone: phone,
        mobile: mobile,
        email: email,
        niip: niip,
        tax: tax,
        npi: npi,
    };
};

export const flatObjectFromFhirMyOrganization = (props, selectedVersion) => {
    debugger;
    if (Object.keys(props).length < 1) return false;

    const identifier = props?.identifier;
    const niip =
        identifier?.[
            _.findIndex(identifier, o => o?.type?.coding?.[0].code === 'NIIP')
        ]?.value;
    const tax =
        identifier?.[
            _.findIndex(identifier, o => o?.type?.coding?.[0].code === 'TAX')
        ]?.value;
    const npi =
        selectedVersion === 'IN'
            ? identifier?.[
                  _.findIndex(
                      identifier,
                      o => o?.system === 'http://hl7.org/fhir/sid/us-npi'
                  )
              ]?.value
            : identifier?.[
                  _.findIndex(
                      identifier,
                      o => o?.system === 'http://hl7.org/fhir/sid/us-npi'
                  )
              ]?.value;

    const addressTemp = props?.contact?.[0]?.address;
    const addressObject = {
        addressLine1: addressTemp?.line?.[0],
        addressLine2: addressTemp?.line?.[1],
        city: addressTemp?.city,
        state: addressTemp?.state,
        country: addressTemp?.country,
        postalCode: addressTemp?.postalCode,
    };

    const typeObject = {
        code: props?.type?.[0]?.coding?.[0]?.code,
        display: props?.type?.[0]?.coding?.[0]?.display,
    };

    let rawPhoneItems = props?.contact[0]?.telecom?.filter(
        o => o.system === 'phone'
    );
    let phone =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'work')]
            ?.value;
    let mobile =
        rawPhoneItems?.[_.findIndex(rawPhoneItems, o => o.use === 'hone')]
            ?.value;
    let email = props?.telecom?.filter(o => o.system === 'email')?.[0]?.value;

    // console.log("MBX", email);
    // const phone = props?.telecom?.[0]?.value;
    // const mobile = props?.telecom?.[1]?.value;
    // const email = props?.telecom?.[2]?.value;

    return {
        id: props?.id,
        name: props?.name,
        address: addressObject,
        fullRawData: props,
        type: typeObject,
        phone: phone,
        mobile: mobile,
        email: email,
        niip: niip,
        tax: tax,
        npi: npi,
    };
};
